"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrackMarketplaceSearchAppliedEffect = exports.useTrackMarketplaceNextPageEffect = exports.useTrackMarketplaceProductSelected = exports.useTrackMarketplaceProductViewedEffect = exports.useTrackMarketplaceVisitedEffect = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _services = require("@alycecom/services");

var _auth = require("../../../Auth/store/auth.selectors");

var _gift = require("../../store/gift/gift.selector");

var _marketplace = require("../../store/marketplace/marketplace.selector");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useTrackMarketplacePayload = function useTrackMarketplacePayload(_ref) {
  var categories = _ref.categories,
      types = _ref.types,
      countryId = _ref.countryId,
      recipientId = _ref.recipientId,
      senderId = _ref.senderId,
      search = _ref.search,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? {} : _ref$sort,
      orgId = _ref.orgId,
      orgName = _ref.orgName;
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var page = (0, _reactRedux.useSelector)(_marketplace.getCurrentMarketplacePage);
  var adminId = (0, _reactRedux.useSelector)(_auth.getLoginAsAdminId);
  return (0, _react.useMemo)(function () {
    return {
      payload: {
        search,
        typeFilter: types,
        categoryFilter: categories,
        locationFilter: countryId,
        brandFilter: [],
        senderId,
        sortColumn: sort['sort[column]'] || null,
        sortOrder: sort['sort[order]'] || null,
        page: page || 1,
        giftId,
        recipientId,
        orgId,
        orgName,
        adminId
      },
      options: {
        groupId: orgId,
        traits: {
          adminId
        }
      }
    };
  }, [adminId, categories, countryId, giftId, orgId, orgName, page, recipientId, search, senderId, sort, types]);
};

var useTrackMarketplaceVisitedEffect = function useTrackMarketplaceVisitedEffect(_ref2) {
  var isMarketplaceOpen = _ref2.isMarketplaceOpen,
      data = (0, _objectWithoutProperties2.default)(_ref2, ["isMarketplaceOpen"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isSent = _useState2[0],
      setIsSent = _useState2[1];

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var _useTrackMarketplaceP = useTrackMarketplacePayload(data),
      payload = _useTrackMarketplaceP.payload,
      options = _useTrackMarketplaceP.options;

  (0, _react.useEffect)(function () {
    if (isMarketplaceOpen) {
      setIsSent(false);
    }
  }, [isMarketplaceOpen]);
  (0, _react.useEffect)(function () {
    if (isSent || !isMarketplaceOpen) return;
    trackEvent('Marketplace — visited', payload, options);
    setIsSent(true);
  }, [isMarketplaceOpen, isSent, options, payload, trackEvent]);
};

exports.useTrackMarketplaceVisitedEffect = useTrackMarketplaceVisitedEffect;

var useTrackMarketplaceProductViewedEffect = function useTrackMarketplaceProductViewedEffect(data) {
  var _ref3 = (0, _reactRedux.useSelector)(_marketplace.getProduct) || {},
      _ref3$id = _ref3.id,
      productId = _ref3$id === void 0 ? null : _ref3$id;

  var proposedProducts = (0, _reactRedux.useSelector)(_gift.getProposedProducts) || [];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isProductViewed = _useState4[0],
      setIsProductViewed = _useState4[1];

  var _TrackEvent$useTrackE2 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE2.trackEvent;

  var _useTrackMarketplaceP2 = useTrackMarketplacePayload(data),
      payload = _useTrackMarketplaceP2.payload,
      options = _useTrackMarketplaceP2.options;

  var isProposedProduct = proposedProducts.some(function (product) {
    return product.id === productId;
  });
  (0, _react.useEffect)(function () {
    if (productId && !isProposedProduct) {
      setIsProductViewed(true);
    }
  }, [isProposedProduct, productId]);
  (0, _react.useEffect)(function () {
    if (isProductViewed) {
      trackEvent('Product - viewed', _objectSpread({
        productId
      }, payload), options);
      setIsProductViewed(false);
    }
  }, [isProductViewed, options, payload, productId, trackEvent]);
};

exports.useTrackMarketplaceProductViewedEffect = useTrackMarketplaceProductViewedEffect;

var useTrackMarketplaceProductSelected = function useTrackMarketplaceProductSelected(data) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var proposedProducts = (0, _reactRedux.useSelector)(_gift.getProposedProducts) || [];

  var _TrackEvent$useTrackE3 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE3.trackEvent;

  var _useTrackMarketplaceP3 = useTrackMarketplacePayload(data),
      payload = _useTrackMarketplaceP3.payload,
      options = _useTrackMarketplaceP3.options;

  return (0, _react.useCallback)(function (productId) {
    var isProposedProduct = proposedProducts.some(function (product) {
      return product.id === productId;
    });

    if (isProposedProduct) {
      return;
    }

    trackEvent('Product - selected', _objectSpread({
      productId
    }, payload), options);
  }, [options, payload, proposedProducts, trackEvent]);
};

exports.useTrackMarketplaceProductSelected = useTrackMarketplaceProductSelected;

var useTrackMarketplaceNextPageEffect = function useTrackMarketplaceNextPageEffect(data) {
  var page = (0, _reactRedux.useSelector)(_marketplace.getCurrentMarketplacePage);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isPageChanged = _useState6[0],
      setIsPageChanged = _useState6[1];

  var _TrackEvent$useTrackE4 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE4.trackEvent;

  var _useTrackMarketplaceP4 = useTrackMarketplacePayload(data),
      payload = _useTrackMarketplaceP4.payload,
      options = _useTrackMarketplaceP4.options;

  (0, _react.useEffect)(function () {
    if (page > 1) {
      setIsPageChanged(true);
    }
  }, [page]);
  (0, _react.useEffect)(function () {
    if (isPageChanged) {
      trackEvent('Marketplace — next page requested', payload, options);
      setIsPageChanged(false);
    }
  }, [isPageChanged, options, payload, trackEvent]);
};

exports.useTrackMarketplaceNextPageEffect = useTrackMarketplaceNextPageEffect;

var useTrackMarketplaceSearchAppliedEffect = function useTrackMarketplaceSearchAppliedEffect(_ref4) {
  var isLoading = _ref4.isLoading,
      data = (0, _objectWithoutProperties2.default)(_ref4, ["isLoading"]);
  var search = data.search;

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isSearchChanged = _useState8[0],
      setIsSearchChanged = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      setIsMount = _useState10[1];

  var _TrackEvent$useTrackE5 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE5.trackEvent;

  var _useTrackMarketplaceP5 = useTrackMarketplacePayload(data),
      payload = _useTrackMarketplaceP5.payload,
      options = _useTrackMarketplaceP5.options;

  (0, _react.useEffect)(function () {
    setIsMount(function (isMounted) {
      if (isMounted) {
        setIsSearchChanged(true);
      }

      return true;
    });
  }, [search]);
  (0, _react.useEffect)(function () {
    if (!isLoading && isSearchChanged) {
      trackEvent('Marketplace search — applied', payload, options);
      setIsSearchChanged(false);
    }
  }, [isLoading, isSearchChanged, options, payload, trackEvent]);
};

exports.useTrackMarketplaceSearchAppliedEffect = useTrackMarketplaceSearchAppliedEffect;